import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M167.5 261.8L285 144.3 168.8 28.2l-26.4 26.4 73.7 73.7-210.2-1.8-.9 36.3 210 1.6-72.5 72.5z"
})), 'TrendEvenIcon');